export default __webpack_public_path__ + "images/icon-park-outline_recycling.png";